/**
* Scrolling Accordions JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Accordions component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-accordions',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.scrolling-accordions__accordion-section-trigger' ).on( 'toggleAfter', function( event ) {
        $( this ).closest( 'section' ).find( '.scrolling-accordions__accordion-section-open span' ).text( $( this ).text() );
      } );

      $( '.scrolling-accordions__link' ).on( 'click', function( e ) {
        const href = $( this ).attr( 'href' );
        const el = $( href );
        if ( el.length > 0 ) {
          e.preventDefault();
          window.scrollTo( {
            top: el.offset().top - $( 'header' ).height() - 64,
            behavior: 'smooth',
          } );
        }
      } );

      if ( window.innerWidth > 768 ) {
        let topOffset = $( 'header' ).height() + 40;

        if ( $( 'body.logged-in' ).length > 0 ) {
          topOffset += $( '#wpadminbar' ).height();
        }

        $( '.scrolling-accordions__section' ).each( function() {
          const jumpLink = $( this ).data( 'jump-link' );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: `top top+=${topOffset}`,
              end: `bottom top+=${topOffset}`,
              markers: false,
              onEnter: ( {progress, direction, isActive} ) => {
                $( jumpLink ).addClass( 'is-active' );
              },
              onLeave: ( {progress, direction, isActive} ) => {
                $( jumpLink ).removeClass( 'is-active' );
              },
              onEnterBack: ( {progress, direction, isActive} ) => {
                $( jumpLink ).addClass( 'is-active' );
              },
              onLeaveBack: ( {progress, direction, isActive} ) => {
                $( jumpLink ).removeClass( 'is-active' );
              },
            },
          } );
          tl.to( $( jumpLink ), {
            addClass: 'is-active',
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-accordions', COMPONENT );
} )( app );
